<template>
  <b-modal
    v-model="editorShown"
    title="Appointment Request"
    size="md-lg"
    centered
    scrollable
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    modal-class="new-verification-modal"
    header-class="bg-purple"
    @close="closeModal"
  >
    <template v-slot:modal-footer>
      <b-col>
        <div class="d-flex justify-content-center pb-2 text-right">
          <b-button
            :variant="
              approved
                ? 'outline-secondary'
                : 'danger' && denied
                ? 'light'
                : 'danger'
            "
            :class="denied ? 'text-danger font-weight-bold' : ''"
            @click="denyAppointmentRequest"
          >
            <b-icon icon="x" aria-hidden="true"></b-icon>
            Deny
          </b-button>
          <span class="px-2"></span>
          <b-button
            class="ml-2"
            :variant="
              denied
                ? 'outline-secondary'
                : 'success' && approved
                ? 'light'
                : 'success'
            "
            :class="approved ? 'text-success font-weight-bold' : ''"
            @click="approveAppointmentRequest"
          >
            <b-icon icon="check" aria-hidden="true"></b-icon>
            Approve
          </b-button>
        </div>
        <div class="d-flex justify-content-end pt-2 text-right">
          <b-button variant="secondary" @click="closeModal">
            Close
          </b-button>
          <b-button
            :disabled="!approved && !denied"
            class="ml-2"
            variant="primary"
            @click="save"
          >
            Save & Next
          </b-button>
        </div>
      </b-col>
    </template>

    <b-row v-if="appointmentRequestData">
      <b-col cols="6" class="border-right">
        <b-row>
          <b-col>
            <h6
              :class="
                appointmentRequestData.type == 'NewPatient'
                  ? 'text-warning'
                  : 'text-success'
              "
              class="font-weight-bold"
            >
              {{
                appointmentRequestData.type == "NewPatient"
                  ? "New Patient"
                  : "Existing Patient"
              }}
            </h6>
          </b-col>
          <b-col>
            <div>
              <b-button
                v-if="
                  !patientId &&
                    appointmentRequestData.type == 'NewPatient' &&
                    showButtonDuplicateUser
                "
                @click="showDuplicateAlert"
                block
                variant="warning"
                >Possible client duplication</b-button
              >
            </div></b-col
          >
        </b-row>
        <b-row>
          <b-col>
            <b-row class="d-flex py-1">
              <b-col class="fw-bold" cols="3"><small>First Name:</small></b-col>
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{ appointmentRequestData.firstName }}</small></b-col
              >
              <b-col v-else>
                <b-input v-model="appointmentRequestData.firstName" />
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"
                ><small class="fw-bold">Middle Name:</small></b-col
              >
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{ appointmentRequestData.middleName }}</small></b-col
              >
              <b-col v-else>
                <b-input v-model="appointmentRequestData.middleName" />
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"><small class="fw-bold">Last Name:</small></b-col>
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{ appointmentRequestData.lastName }}</small></b-col
              >
              <b-col v-else>
                <b-input
                  v-model="appointmentRequestData.lastName"
                  @blur="checkForDuplicatedPatient"
                />
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"
                ><small class="fw-bold">Preferred Name:</small></b-col
              >
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{
                  appointmentRequestData.preferredName
                }}</small></b-col
              >
              <b-col v-else>
                <b-input v-model="appointmentRequestData.preferredName" />
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"
                ><small class="fw-bold">Date of Birth:</small></b-col
              >
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{ dateOfBirth }}</small></b-col
              >
              <b-col v-else>
                <date-picker
                  v-model="dateOfBirth"
                  @handleBlur="checkForDuplicatedPatient"
                />
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"><small class="fw-bold">SSN:</small></b-col>
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{ appointmentRequestData.ssn }}</small></b-col
              >
              <b-col v-else>
                <b-form-group
                  :state="formErrors.ssn.length == 0 ? null : false"
                  :invalid-feedback="formErrors.ssn.join(', ')"
                >
                  <b-input
                    v-model="appointmentRequestData.ssn"
                    :state="formErrors.ssn.length == 0 ? null : false"
                    @blur="checkForDuplicatedPatient"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"><small class="fw-bold">Legal Sex:</small></b-col>
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{
                  appointmentRequestData.gender
                    ? appointmentRequestData.gender.name
                    : ""
                }}</small></b-col
              >
              <b-col v-else>
                <v-select
                  v-model="genderSelected"
                  :options="genders"
                ></v-select>
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"
                ><small class="fw-bold">Mobile Phone Number:</small></b-col
              >
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small> {{ appointmentRequestData.phone }} </small></b-col
              >
              <b-col v-else>
                <phone-input
                  ref="phoneInput"
                  defaultCountry="US"
                  v-model="appointmentRequestData.phone"
                  trim
                  @handleBlur="checkForDuplicatedPatient"
                ></phone-input>
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"
                ><small class="fw-bold">Other Phone:</small></b-col
              >
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>
                  {{ appointmentRequestData.landLineNumber }}
                </small></b-col
              >
              <b-col v-else>
                <phone-input
                  ref="landPhoneInput"
                  defaultCountry="US"
                  v-model="appointmentRequestData.landLineNumber"
                  trim
                  @handleBlur="checkForDuplicatedPatient"
                ></phone-input>
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"><small class="fw-bold">Contact By:</small></b-col>
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>
                  {{
                    appointmentRequestData.contactPreference == "0"
                      ? "Mobile Phone"
                      : appointmentRequestData.contactPreference == "1"
                      ? "Other Phone"
                      : "Both"
                  }}
                </small></b-col
              >
              <b-col v-else>
                <b-form-radio-group
                  v-model="appointmentRequestData.contactPreference"
                >
                  <b-form-radio
                    v-for="(option, index) in contactPreferences"
                    :key="index"
                    :value="index"
                    class="mr-4"
                    >{{ option }}
                  </b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"><small class="fw-bold">Email:</small></b-col>
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{ appointmentRequestData.email }}</small></b-col
              >
              <b-col v-else>
                <b-form-input
                  v-model="appointmentRequestData.email"
                  @blur="checkForDuplicatedPatient"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"
                ><small class="fw-bold">Address Line 1:</small></b-col
              >
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{ appointmentRequestData.addressLine1 }}</small></b-col
              >
              <b-col v-else>
                <b-form-input
                  v-model="appointmentRequestData.addressLine1"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"
                ><small class="fw-bold">Address Line 2:</small></b-col
              >
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{ appointmentRequestData.addressLine2 }}</small></b-col
              >
              <b-col v-else>
                <b-form-input
                  v-model="appointmentRequestData.addressLine2"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"><small class="fw-bold">City:</small></b-col>
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{ appointmentRequestData.city }}</small></b-col
              >
              <b-col v-else>
                <b-form-input
                  v-model="appointmentRequestData.city"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"><small class="fw-bold">State:</small></b-col>
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{
                  appointmentRequestData.state
                    ? appointmentRequestData.state.name
                    : ""
                }}</small></b-col
              >
              <b-col v-else>
                <v-select v-model="stateSelected" :options="states"></v-select>
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"><small class="fw-bold">Zip Code:</small></b-col>
              <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                ><small>{{ appointmentRequestData.zipcode }}</small></b-col
              >
              <b-col v-else>
                <b-form-input
                  v-model="appointmentRequestData.zipcode"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row
              class="d-flex py-1"
              v-if="appointmentRequestData.nameOnBehalfOf"
            >
              <b-col cols="3"
                ><small class="fw-bold">Person in behalf of the patient:</small>
              </b-col>
              <b-col class="mt-4">
                {{ appointmentRequestData.nameOnBehalfOf }} ({{
                  appointmentRequestData.relationshipOnBehalfOf?.name
                }})
              </b-col>
            </b-row>
            <b-row class="d-flex py-1">
              <b-col cols="3"
                ><small class="fw-bold">General Notes:</small>
              </b-col>

              <b-col>
                <p>{{ appointmentRequestData.generalNotes }}</p>
              </b-col>
            </b-row>
            <b-row
              class="d-flex py-1"
              v-if="appointmentRequestData.type == 'NewPatient'"
            >
              <b-col>
                <input
                  type="checkbox"
                  id="portal_user"
                  v-model="newPortalUser"
                />
                <label for="portal_user" class="ml-2">
                  Create Patient Portal Account
                </label>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-row class="py-3">
              <b-col>
                <h6 class="font-weight-bold">Appointment:</h6>
              </b-col>
            </b-row>
            <b-form-group
              :state="formErrors.dateTimeDuration.length == 0 ? null : false"
              :invalid-feedback="formErrors.dateTimeDuration.join(', ')"
            >
              <b-row>
                <b-col>
                  <b-row class="d-flex py-1">
                    <b-col cols="3" class="fw-bold"
                      ><small>Provider:</small></b-col
                    >
                    <b-col>
                      <v-select
                        :options="providerOptions"
                        v-model="providerSelected"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="3"
                      ><small class="fw-bold">Date & Time:</small></b-col
                    >
                    <b-col>
                      <date-time-picker v-model="appointmentStartDate" />
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="3"
                      ><small class="fw-bold">Duration:</small></b-col
                    >
                    <b-col>
                      <b-input type="number" v-model="duration" />
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="3"
                      ><small class="fw-bold">Service:</small></b-col
                    >
                    <b-col>
                      <v-select v-model="service" :options="serviceOptions" />
                    </b-col>
                  </b-row>
                  <div style="margin-left:135px">
                    <b-form-group v-if="isZoomEnabled" class="mt-2">
                      <div class="d-flex align-items-center">
                        <vue-toggles
                          :disabled="!providerSelected"
                          @click="zoomMeeting = !zoomMeeting"
                          :value="zoomMeeting"
                          height="25"
                          width="45"
                          checkedBg="#34C759"
                          uncheckedBg="#FF6161"
                          class="mr-2"
                        />
                        <span class="mr-2">Zoom Meeting</span>
                        <img
                          :src="require('../../assets/zoom_icon.png')"
                          width="30"
                        />
                      </div>
                      <div
                        v-if="!providerSelected"
                        class="text-danger mt-2"
                        style="font-size: 15px"
                      >
                        Select Provider to attach a Zoom meeting.
                      </div>
                    </b-form-group>
                    <b-form-group v-if="isTeamsEnabled" class="mt-2">
                      <div class="d-flex align-items-center">
                        <vue-toggles
                          @click="teamsMeeting = !teamsMeeting"
                          :value="teamsMeeting"
                          height="25"
                          width="45"
                          checkedBg="#34C759"
                          uncheckedBg="#FF6161"
                          class="mr-2"
                        />
                        <span class="mr-2">Teams Meeting</span>
                        <img
                          :src="require('../../assets/icons/teams.png')"
                          width="30"
                        />
                      </div>
                    </b-form-group>
                  </div>
                  <b-row class="d-flex py-1" v-if="placeOfService">
                    <b-col cols="3"
                      ><small class="fw-bold">Place of service:</small></b-col
                    >
                    <b-col>
                      <v-select
                        v-model="placeOfService"
                        :options="placesOfService"
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          v-if="
            appointmentRequestData.type == 'NewPatient' ||
              (appointmentRequestData.type == 'ExistingPatient' && hasInsurance)
          "
        >
          <b-col>
            <b-row class="py-2">
              <b-col>
                <h6 class="fw-bold">Insurance:</h6>
              </b-col>
            </b-row>
            <b-row cols="2">
              <b-col>
                <image-picker
                  v-model="images.insuranceCardFrontBase64"
                  :serverImageUrl="images.insuranceCardFrontUrl"
                  :readOnly="appointmentRequestData.type == 'ExistingPatient'"
                  labelText="Card Front"
                />
              </b-col>
              <b-col>
                <image-picker
                  v-model="images.insuranceCardBackBase64"
                  :serverImageUrl="images.insuranceCardBackUrl"
                  :readOnly="appointmentRequestData.type == 'ExistingPatient'"
                  labelText="Card Back"
                />
              </b-col>
            </b-row>
            <b-row class="py-2">
              <b-col>
                <b-row class="d-flex py-1">
                  <b-col cols="4" class="fw-bold"
                    ><small>Insurance Company:</small></b-col
                  >
                  <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                    ><small>{{
                      appointmentRequestData.appointmentRequestInsurances[0]
                        ?.insuranceCompany.name ?? ""
                    }}</small></b-col
                  >
                  <b-col v-else>
                    <b-form-group
                      :state="
                        formErrors.insuranceSelected.length == 0 ? null : false
                      "
                      :invalid-feedback="
                        formErrors.insuranceSelected.join(', ')
                      "
                    >
                      <v-select
                        placeholder="Search for insurance companies"
                        v-model="insuranceSelected"
                        :options="insuranceCompanies"
                        @search="fetchInsuranceCompanies"
                      >
                        <template #no-options="{ search }">
                          {{
                            search && search.length > 3
                              ? "Sorry, no matching options"
                              : ""
                          }}
                        </template>
                        <template #open-indicator>
                          <span></span>
                        </template>
                      </v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="d-flex py-1">
                  <b-col cols="4"
                    ><small class="fw-bold">Member #: </small></b-col
                  >
                  <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                    ><small>{{
                      appointmentRequestData.appointmentRequestInsurances[0]
                        ?.memberIdentifier ?? ""
                    }}</small></b-col
                  >
                  <b-col v-else>
                    <b-form-group
                      :state="
                        formErrors.memberIdentifier.length == 0 ? null : false
                      "
                      :invalid-feedback="formErrors.memberIdentifier.join(', ')"
                    >
                      <b-input v-model="memberIdentifier" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="d-flex py-1">
                  <b-col cols="4"
                    ><small class="fw-bold">Group #: </small></b-col
                  >
                  <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                    ><small>{{
                      appointmentRequestData.appointmentRequestInsurances[0]
                        ?.groupNo ?? ""
                    }}</small></b-col
                  >
                  <b-col v-else>
                    <b-form-group
                      :state="formErrors.groupNo.length == 0 ? null : false"
                      :invalid-feedback="formErrors.groupNo.join(', ')"
                    >
                      <b-input v-model="groupNo" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="d-flex py-1">
                  <b-col cols="4"
                    ><small class="fw-bold">Relationship:</small></b-col
                  >
                  <b-col v-if="appointmentRequestData.type == 'ExistingPatient'"
                    ><small>{{
                      appointmentRequestData.appointmentRequestInsurances[0]
                        ?.relationship.name
                    }}</small></b-col
                  >
                  <b-col v-else>
                    <b-form-group
                      :state="
                        formErrors.relationshipSelected.length == 0
                          ? null
                          : false
                      "
                      :invalid-feedback="
                        formErrors.relationshipSelected.join(', ')
                      "
                    >
                      <v-select
                        v-model="relationshipSelected"
                        :options="relationships"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <div
              v-if="
                relationshipSelected &&
                  relationshipSelected?.label !== 'Self' &&
                  relationshipSelected?.label !== null
              "
            >
              <b-row>
                <b-col
                  ><small class="font-weight-bold"
                    >Subscriber Information:</small
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-row class="d-flex py-1">
                    <b-col cols="4" class="fw-bold"
                      ><small>First Name:</small></b-col
                    >
                    <b-col
                      v-if="appointmentRequestData.type == 'ExistingPatient'"
                      ><small>{{ subscriberInfo.firstName }}</small></b-col
                    >
                    <b-col v-else>
                      <b-input v-model="subscriberInfo.firstName" />
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="4"
                      ><small class="fw-bold">Middle Name:</small></b-col
                    >
                    <b-col
                      v-if="appointmentRequestData.type == 'ExistingPatient'"
                      ><small>{{ subscriberInfo.middleName }}</small></b-col
                    >
                    <b-col v-else>
                      <b-input v-model="subscriberInfo.middleName" />
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="4"
                      ><small class="fw-bold">Last Name:</small></b-col
                    >
                    <b-col
                      v-if="appointmentRequestData.type == 'ExistingPatient'"
                      ><small>{{ subscriberInfo.lastName }}</small></b-col
                    >
                    <b-col v-else>
                      <b-input v-model="subscriberInfo.lastName" />
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="4"
                      ><small class="fw-bold">Date of Birth:</small></b-col
                    >
                    <b-col
                      v-if="appointmentRequestData.type == 'ExistingPatient'"
                      ><small>{{
                        this.formatDateOnlyPrettyShort(
                          subscriberInfo.dateOfBirth
                        )
                      }}</small></b-col
                    >
                    <b-col v-else>
                      <date-picker v-model="subscriberInfo.dateOfBirth" />
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="4"
                      ><small class="fw-bold">Legal Sex:</small></b-col
                    >
                    <b-col
                      v-if="appointmentRequestData.type == 'ExistingPatient'"
                      ><small>{{ subscriberInfo.gender }}</small></b-col
                    >
                    <b-col v-else>
                      <v-select
                        v-model="subscriberInfo.gender"
                        :options="genders"
                      ></v-select>
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="4"
                      ><small class="fw-bold"
                        >Mobile Phone Number:</small
                      ></b-col
                    >
                    <b-col
                      v-if="appointmentRequestData.type == 'ExistingPatient'"
                      ><small>
                        {{ subscriberInfo.phone }}
                      </small></b-col
                    >
                    <b-col v-else>
                      <phone-input
                        ref="phoneInput"
                        defaultCountry="US"
                        v-model="subscriberInfo.phone"
                        trim
                      ></phone-input>
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="4"
                      ><small class="fw-bold">Address Line 1:</small></b-col
                    >
                    <b-col
                      v-if="appointmentRequestData.type == 'ExistingPatient'"
                      ><small>{{ subscriberInfo.addressLine1 }}</small></b-col
                    >
                    <b-col v-else>
                      <b-input v-model="subscriberInfo.addressLine1" />
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="4"
                      ><small class="fw-bold">Address Line 2:</small></b-col
                    >
                    <b-col
                      v-if="appointmentRequestData.type == 'ExistingPatient'"
                      ><small>{{ subscriberInfo.addressLine2 }}</small></b-col
                    >
                    <b-col v-else>
                      <b-input v-model="subscriberInfo.addressLine2" />
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="4"><small class="fw-bold">City:</small></b-col>
                    <b-col
                      v-if="appointmentRequestData.type == 'ExistingPatient'"
                      ><small>{{ subscriberInfo.city }}</small></b-col
                    >
                    <b-col v-else>
                      <b-input v-model="subscriberInfo.city" />
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="4"
                      ><small class="fw-bold">State:</small></b-col
                    >
                    <b-col
                      v-if="appointmentRequestData.type == 'ExistingPatient'"
                      ><small>{{ subscriberInfo.state }}</small></b-col
                    >
                    <b-col v-else>
                      <v-select
                        v-model="subscriberInfo.state"
                        :options="states"
                      ></v-select>
                    </b-col>
                  </b-row>
                  <b-row class="d-flex py-1">
                    <b-col cols="4"
                      ><small class="fw-bold">Zip Code:</small></b-col
                    >
                    <b-col
                      v-if="appointmentRequestData.type == 'ExistingPatient'"
                      ><small>{{ subscriberInfo.zipcode }}</small></b-col
                    >
                    <b-col v-else>
                      <b-input v-model="subscriberInfo.zipcode" />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <eoc-possible-duplications
      v-if="this.showDialogDuplicateUser"
      v-model="this.showDialogDuplicateUser"
      :possibleUsersDuplicates="this.possibleUsersDuplicates"
      @cancel="cancel"
      @addUser="setPatient"
    />
  </b-modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AppointmentRequestServer from "../../server/appointmentRequest";
import PortalAccessServer from "../../server/portalAccess";
import patientServer from "../../server/patient";
import eocServer from "../../server/eoc";
import userServer from "../../server/user";
import serviceServer from "../../server/service";
import avatarServer from "../../server/avatar";
import serverCore from "../../server/core";
import { calculateDurationInMinutes } from "../../helpers/date";
import DatePicker from "../controls/DatePicker.vue";
import DateTimePicker from "../controls/DateTimePicker.vue";
import PhoneInput from "../controls/PhoneInput.vue";
import insuranceCompanyServer from "@/server/insuranceCompany";
import ImagePicker from "../controls/ImagePicker";
import moment from "moment";
import EocPossibleDuplications from "../episode_of_care/EocPossibleDuplications";
import { validateRequired } from "../../helpers/validation";
export default {
  name: "AppointmentRequestViewModal",
  components: {
    DateTimePicker,
    DatePicker,
    PhoneInput,
    ImagePicker,
    EocPossibleDuplications
  },
  props: ["appointmentRequestId", "appointmentRequestfilters"],
  data() {
    return {
      appointmentRequestData: null,
      approved: false,
      denied: false,
      appointmentRequestIdLocal: null,
      appointmentRequestfiltersLocal: null,
      hasInsurance: false,
      insuranceImageFront: null,
      insuranceImageBack: null,
      genderSelected: null,
      stateSelected: null,
      providerSelected: null,
      insuranceSelected: null,
      relationshipSelected: null,
      newPortalUser: true,
      users: [],
      duration: null,
      serviceOptions: [],
      insuranceCompanies: [],
      service: null,
      placeOfService: null,
      zoomMeeting: false,
      teamsMeeting: false,
      images: {
        insuranceCardBackBase64: null,
        insuranceCardBackUrl: null,
        insuranceCardFrontBase64: null,
        insuranceCardFrontUrl: null
      },
      dateOfBirth: null,
      appointmentStartDate: null,
      memberIdentifier: null,
      groupNo: null,
      subscriberInfo: {
        firstName: null,
        lastName: null,
        middleName: null,
        dateOfBirth: null,
        gender: null,
        phone: null,
        addressLine1: null,
        addressLine2: null,
        city: null,
        state: null,
        zipcode: null
      },
      possibleUsersDuplicates: [],
      alreadyShownAlert: false,
      showDialogDuplicateUser: false,
      showButtonDuplicateUser: false,
      patientId: null,
      contactPreferences: ["Mobile Phone", "Other Phone", "Both"],
      formErrors: {
        insuranceSelected: [],
        memberIdentifier: [],
        groupNo: [],
        relationshipSelected: [],
        dateTimeDuration: [],
        ssn: []
      }
    };
  },
  async mounted() {
    this.appointmentRequestIdLocal = this.appointmentRequestId;
    this.appointmentRequestfiltersLocal = this.appointmentRequestfilters;
    await this.fetchData();
    await this.fetchUsers();
    await this.fetchServices();
    await this.fetchPlacesOfService();
    await this.fetchRelationships();
    await this.fetchGenders();
    await this.fetchStates();
    await this.fillValues();
    await this.checkForDuplicatedPatient();
  },
  methods: {
    ...mapActions("client", [
      "fetchPlacesOfService",
      "fetchRelationships",
      "fetchStates",
      "fetchGenders"
    ]),
    ...mapActions("layout", ["showAlertSuccess", "showError"]),
    isAnyFillInsurancesForm: function() {
      return [
        this.insuranceSelected != null,
        this.memberIdentifier != null,
        this.groupNo != null,
        this.relationshipSelected != null
      ].some(x => x);
    },
    clearErrors: function() {
      this.formErrors = {
        insuranceSelected: [],
        memberIdentifier: [],
        groupNo: [],
        relationshipSelected: [],
        dateTimeDuration: [],
        ssn: []
      };
    },
    validateInsuranceSubmit: function() {
      let withoutErrors = true;

      if (!validateRequired(this.insuranceSelected)) {
        this.formErrors.insuranceSelected.push("This field is required");
        withoutErrors = false;
      }
      if (!validateRequired(this.memberIdentifier)) {
        this.formErrors.memberIdentifier.push("This field is required");
        withoutErrors = false;
      }
      if (!validateRequired(this.groupNo)) {
        this.formErrors.groupNo.push("This field is required");
        withoutErrors = false;
      }
      if (!validateRequired(this.relationshipSelected)) {
        this.formErrors.relationshipSelected.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    validatedateTimeDuration: function() {
      this.clearErrors();
      let withoutErrors = true;
      let appointmentStartDateTime = this.formatTimeOnlyMysql(this.startDate);
      var days = [
        this.location.operatesOnSunday,
        this.location.operatesOnMonday,
        this.location.operatesOnTuesday,
        this.location.operatesOnWednesday,
        this.location.operatesOnThursday,
        this.location.operatesOnFriday,
        this.location.operatesOnSaturday
      ];
      let dayOfWeek = new Date(this.startDate).getDay();
      let isOperate = days[dayOfWeek];

      if (
        (this.selectedLocation &&
          appointmentStartDateTime < this.location.operationStarts) ||
        (this.selectedLocation &&
          appointmentStartDateTime > this.location.operationEnds) ||
        (!this.selectedLocation &&
          appointmentStartDateTime < this.location.operationStarts) ||
        (!this.selectedLocation &&
          appointmentStartDateTime > this.location.operationEnds) ||
        !isOperate
      ) {
        this.formErrors.dateTimeDuration.push(
          "Events cannot be created outside hours of operation"
        );
        withoutErrors = false;
      }

      return withoutErrors;
    },
    validatePatientData: function() {
      let withoutErrors = true;
      

      return withoutErrors;
    },
    async checkForDuplicatedPatient() {
      if (!this.patientId && this.appointmentRequestData.type == "NewPatient") {
        const fields = [
          this.appointmentRequestData.ssn,
          this.appointmentRequestData.lastName,
          this.dateOfBirth,
          this.appointmentRequestData.phone.replace(
            this.appointmentRequestData.phone.slice(0, 2),
            ""
          ),
          this.appointmentRequestData.landLineNumber.replace(
            this.appointmentRequestData.landLineNumber.slice(0, 2),
            ""
          ),
          this.appointmentRequestData.email
        ];
        let isCombination = fields.filter(x => x != "").filter(x => x != null);
        if (isCombination.length >= 2) {
          await patientServer
            .findPosibleDuplications(
              {
                lastName: this.appointmentRequestData.lastName,
                dateOfBirth: this.formatDateOnlyMysql(this.dateOfBirth),
                ssn: this.appointmentRequestData.ssn,
                phone: this.appointmentRequestData.phone,
                landLineNumber: this.appointmentRequestData.landLineNumber,
                countryCode: "+" + this.activePhoneCountry,
                landLineNumberCountryCode: "+" + this.activeLineNumberCountry,
                email: this.appointmentRequestData.email
              },
              { "Hide-Loading": true }
            )
            .then(result => {
              if (result.length > 0) {
                this.possibleUsersDuplicates = result;
                if (!this.alreadyShownAlert) {
                  this.showDialogDuplicateUser = true;
                  this.alreadyShownAlert = true;
                } else {
                  this.showButtonDuplicateUser = true;
                }
              } else {
                this.showButtonDuplicateUser = false;
              }
            });
        } else {
          if (this.showButtonDuplicateUser) {
            this.showButtonDuplicateUser = false;
          }
        }
      }
    },
    async setPatient(userId) {
      this.patientId = userId;
      await this.initializeClientForm();
      this.showDialogDuplicateUser = false;
    },
    showDuplicateAlert() {
      this.showDialogDuplicateUser = true;
    },
    async initializeClientForm() {
      const patient = await patientServer.get(this.patientId);
      this.appointmentRequestData.firstName = patient.firstName;
      this.appointmentRequestData.middleName = patient.middleName;
      this.appointmentRequestData.lastName = patient.lastName;
      this.appointmentRequestData.preferredName = patient.preferredName;
      this.dateOfBirth = this.formatDateOnly(patient.dateOfBirth);
      this.appointmentRequestData.ssn = patient.ssn;
      this.appointmentRequestData.gender = patient.gender;
      this.appointmentRequestData.phone = patient.phone;
      this.appointmentRequestData.landLineNumber = patient.landLineNumber;
      this.appointmentRequestData.contactPreference =
        patient.contactPreference == "Cellphone"
          ? 0
          : patient.contactPreference == "Landline"
          ? 1
          : 2;
      this.appointmentRequestData.email = patient.email;
      this.appointmentRequestData.addressLine1 = patient.addressLine1;
      this.appointmentRequestData.addressLine2 = patient.addressLine2;
      this.appointmentRequestData.city = patient.city;
      this.appointmentRequestData.state = patient.state;
      this.appointmentRequestData.zipcode = patient.zipcode;
      this.appointmentRequestData.appointmentRequestInsurances = [];
      this.hasInsurance = false;

      if (patient.insurances.length > 0 && patient.billType) {
        const insuranceinfo = patient.insurances[0];
        this.appointmentRequestData.appointmentRequestInsurances.push({
          memberIdentifier: insuranceinfo.memberIdent,
          relationship: insuranceinfo.patientRelationship,
          relationshipSelected: insuranceinfo.patientRelationship,
          insuranceCompany: await insuranceCompanyServer.get(
            insuranceinfo.company.id
          )
        });
        if (insuranceinfo.insuranceCardFrontId) {
          try {
            this.images.insuranceCardFrontBase64 = await this.downloadImage(
              insuranceinfo.insuranceCardFrontId
            );
          } catch (error) {
            console.log(error.message);
          }
          this.images.insuranceCardFrontUrl = this.getImageUrl(
            insuranceinfo.insuranceCardFrontId
          );
        }
        if (insuranceinfo.insuranceCardBackId) {
          try {
            this.images.insuranceCardBackBase64 = await this.downloadImage(
              insuranceinfo.insuranceCardBackId
            );
          } catch (error) {
            console.log(error.message);
          }
          this.images.insuranceCardBackUrl = this.getImageUrl(
            insuranceinfo.insuranceCardBackId
          );
        }
        this.subscriberInfo.firstName = insuranceinfo.insuredFirstName ?? null;
        this.subscriberInfo.middleName =
          insuranceinfo.insuredMiddleName ?? null;
        this.subscriberInfo.lastName = insuranceinfo.insuredLastName ?? null;
        this.subscriberInfo.dateOfBirth = insuranceinfo.insuredDob ?? null;
        this.subscriberInfo.gender = insuranceinfo.insuredGender;
        this.subscriberInfo.phone = insuranceinfo.insuredPhone ?? null;
        this.subscriberInfo.addressLine1 =
          insuranceinfo.insuredAddressLine1 ?? null;
        this.subscriberInfo.addressLine2 =
          insuranceinfo.insuredAddressLine2 ?? null;
        this.subscriberInfo.city = insuranceinfo.insuredCity ?? null;
        this.subscriberInfo.state = insuranceinfo.insuredState;
        this.subscriberInfo.zipcode = insuranceinfo.insuredZipcode ?? null;
        this.hasInsurance = true;
      }

      const eocId = await eocServer.getFromPatientId(patient.id);
      this.appointmentRequestData["episodeOfCare"] = { id: eocId };
      this.appointmentRequestData.type = "ExistingPatient";
    },
    cancel() {
      this.showDialogDuplicateUser = false;
      this.showButtonDuplicateUser = true;
    },
    async fetchUsers() {
      const users = await userServer.getMinimalUsers();
      this.users = users
        .filter(user => user.providerInfo)
        .map(user => ({
          value: user.id,
          label: this.formatUser(user),
          data: user
        }));
    },
    async fetchServices() {
      const services = await serviceServer.query({
        Type: "Service"
      });
      this.serviceOptions = services.map(service => ({
        value: service.id,
        label: `${
          service.billingCodes?.length
            ? service.billingCodes[0].cptCode + " - "
            : ""
        } ${service.name}`,
        data: service
      }));
    },
    fetchInsuranceCompanies: async function(search, loading) {
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = null;
      }
      if (search && search.trim().length >= 3) {
        this.insuranceCompanies = [];
      }

      this.lastTimeout = setTimeout(async () => {
        loading(true);
        if (search.trim().length >= 3) {
          const insuranceCompanies = await insuranceCompanyServer.query(
            { searchPhrase: search, page: 0, pageSize: 1000000 },
            {
              "Hide-Loading": true
            }
          );
          this.insuranceCompanies = insuranceCompanies.records.map(
            insuranceCompany => ({
              value: insuranceCompany.id,
              label: insuranceCompany.name,
              data: insuranceCompany
            })
          );
        } else this.insuranceCompanies = [];
        loading(false);
      }, 1000);
    },
    resetData() {
      this.dateOfBirth = null;
      this.duration = null;
      this.appointmentStartDate = null;
      this.providerSelected = null;
      this.service = null;
      this.placeOfService = null;
      this.genderSelected = null;
      this.stateSelected = null;
      this.subscriberInfo.firstName = null;
      this.subscriberInfo.lastName = null;
      this.subscriberInfo.middleName = null;
      this.subscriberInfo.preferredName = null;
      this.subscriberInfo.dateOfBirth = null;
      this.subscriberInfo.gender = null;
      this.subscriberInfo.phone = null;
      this.subscriberInfo.addressLine1 = null;
      this.subscriberInfo.addressLine2 = null;
      this.subscriberInfo.city = null;
      this.subscriberInfo.state = null;
      this.subscriberInfo.zipcode = null;
      this.relationshipSelected = null;
      this.insuranceSelected = null;
      this.memberIdentifier = null;
      this.groupNo = null;
    },
    async fillValues() {
      this.resetData();
      const insuranceCompanies = await insuranceCompanyServer.query(
        { page: 0, pageSize: 1000000 },
        {
          "Hide-Loading": true
        }
      );
      this.insuranceCompanies = insuranceCompanies.records.map(
        insuranceCompany => ({
          value: insuranceCompany.id,
          label: insuranceCompany.name,
          data: insuranceCompany
        })
      );
      this.dateOfBirth = this.formatDateOnly(
        this.appointmentRequestData.dateOfBirth
      );
      this.duration = this.calculateDuration(
        this.appointmentRequestData.startDateTime,
        this.appointmentRequestData.endDateTime
      );
      this.appointmentStartDate = this.formatDateTimeMysql(
        this.appointmentRequestData.startDateTime
      );
      this.providerSelected = this.providerOptions.find(
        p => p.value == this.appointmentRequestData.provider.id
      );
      this.service = this.serviceOptions.find(
        service => service.value == this.appointmentRequestData.service.id
      );
      this.placeOfService = this.placesOfService.find(
        x => x.value == this.appointmentRequestData.placeOfService?.id
      );
      if (this.appointmentRequestData.type == "NewPatient") {
        this.genderSelected = this.genders.find(
          genders => genders.value == this.appointmentRequestData?.gender?.id
        );
        this.stateSelected = this.states.find(
          states => states.value == this.appointmentRequestData?.state?.id
        );
        if (
          this.appointmentRequestData.appointmentRequestInsurances.length > 0
        ) {
          this.subscriberInfo.firstName = this.appointmentRequestData.appointmentRequestInsurances[0].subscriberFirstName;
          this.subscriberInfo.lastName = this.appointmentRequestData.appointmentRequestInsurances[0].subscriberLastName;
          this.subscriberInfo.middleName = this.appointmentRequestData.appointmentRequestInsurances[0].subscriberMiddleName;
          this.subscriberInfo.preferredName = this.appointmentRequestData.appointmentRequestInsurances[0].subscriberPreferredName;
          this.subscriberInfo.dateOfBirth = this.formatDateOnly(
            this.appointmentRequestData.appointmentRequestInsurances[0]
              .subscriberDateOfBirth
          );
          this.subscriberInfo.gender = this.genders.find(
            genders =>
              genders.value ==
              this.appointmentRequestData.appointmentRequestInsurances[0]
                .subscriberGender?.id
          );
          this.subscriberInfo.phone = this.appointmentRequestData.appointmentRequestInsurances[0].subscriberPhone;
          this.subscriberInfo.addressLine1 = this.appointmentRequestData.appointmentRequestInsurances[0].subscriberAddressLine1;
          this.subscriberInfo.addressLine2 = this.appointmentRequestData.appointmentRequestInsurances[0].subscriberAddressLine2;
          this.subscriberInfo.city = this.appointmentRequestData.appointmentRequestInsurances[0].subscriberCity;
          this.subscriberInfo.state = this.appointmentRequestData
            .appointmentRequestInsurances[0].subscriberState
            ? this.states.find(
                states =>
                  states.value ==
                  this.appointmentRequestData.appointmentRequestInsurances[0]
                    .subscriberState.id
              )
            : null;
          this.subscriberInfo.zipcode = this.appointmentRequestData.appointmentRequestInsurances[0].subscriberZipcode;
          this.relationshipSelected = this.relationships.find(
            p =>
              p.value ==
              this.appointmentRequestData.appointmentRequestInsurances[0]
                .relationship?.id
          );
          this.insuranceSelected = this.insuranceCompanies.find(
            i =>
              i.value ==
              this.appointmentRequestData.appointmentRequestInsurances[0]
                .insuranceCompany?.id
          );
          this.memberIdentifier = this.appointmentRequestData.appointmentRequestInsurances[0]?.memberIdentifier;
          this.groupNo = this.appointmentRequestData.appointmentRequestInsurances[0]?.groupNo;
        }
      }
    },
    async fetchData() {
      const response = await AppointmentRequestServer.find(
        this.appointmentRequestIdLocal
      );
      this.appointmentRequestData = response;
      this.appointmentRequestData.contactPreference =
        response.contactPreference == "Cellphone"
          ? 0
          : response.contactPreference == "Landline"
          ? 1
          : 2;
      this.images.insuranceCardFrontBase64 = null;
      this.images.insuranceCardBackBase64 = null;
      this.images.insuranceCardFrontUrl = null;
      this.images.insuranceCardBackUrl = null;
      if (
        this.appointmentRequestData.appointmentRequestInsurances?.length > 0
      ) {
        this.hasInsurance = true;
        if (
          this.appointmentRequestData.appointmentRequestInsurances[0]
            .insuranceCardFrontId != undefined
        ) {
          try {
            this.images.insuranceCardFrontBase64 = await this.downloadImage(
              this.appointmentRequestData.appointmentRequestInsurances[0]
                .insuranceCardFrontId
            );
          } catch (error) {
            console.log(error.message);
          }
          this.images.insuranceCardFrontUrl = this.getImageUrl(
            this.appointmentRequestData.appointmentRequestInsurances[0]
              .insuranceCardFrontId
          );
        }
        if (
          this.appointmentRequestData.appointmentRequestInsurances[0]
            .insuranceCardBackId != undefined
        ) {
          try {
            this.images.insuranceCardBackBase64 = await this.downloadImage(
              this.appointmentRequestData.appointmentRequestInsurances[0]
                .insuranceCardBackId
            );
          } catch (error) {
            console.log(error.message);
          }
          this.images.insuranceCardBackUrl = this.getImageUrl(
            this.appointmentRequestData.appointmentRequestInsurances[0]
              .insuranceCardBackId
          );
        }
      }
    },
    calculateDuration(dateStart, dateEnd) {
      return calculateDurationInMinutes(dateStart, dateEnd);
    },
    async denyAppointmentRequest() {
      this.denied = true;
      this.approved = false;
    },
    async approveAppointmentRequest() {
      this.denied = false;
      this.approved = true;
    },
    async save() {
      let isOk = false;
      if (!this.validatedateTimeDuration()) {
        return;
      }
      if (!this.validatePatientData()) {
        return;
      }
      const nextAppointment = await AppointmentRequestServer.getNext(
        this.appointmentRequestIdLocal,
        this.appointmentRequestfiltersLocal
      );
      if (this.denied) {
        isOk = await AppointmentRequestServer.delete(
          this.appointmentRequestIdLocal
        );
      } else if (this.approved) {
        if (this.appointmentRequestData.type == "NewPatient") {
          var appointment = {
            FirstName: this.appointmentRequestData.firstName,
            MiddleName: this.appointmentRequestData.middleName,
            LastName: this.appointmentRequestData.lastName,
            PreferredName: this.appointmentRequestData.preferredName,
            DateOfBirth: this.formatDateTimeSql(this.dateOfBirth),
            Ssn: this.appointmentRequestData.ssn,
            GenderId: this.genderSelected?.value ?? null,
            Phone: this.appointmentRequestData.phone,
            LandLineNumber: this.appointmentRequestData.landLineNumber,
            ContactPreference: this.appointmentRequestData.contactPreference,
            Email: this.appointmentRequestData.email,
            AddressLine1: this.appointmentRequestData.addressLine1,
            AddressLine2: this.appointmentRequestData.addressLine2,
            City: this.appointmentRequestData.city,
            StateId: this.stateSelected?.value ?? null,
            Zipcode: this.appointmentRequestData.zipcode,
            Type: this.appointmentRequestData.type,
            EpisodeOfCareId:
              this.appointmentRequestData.episodeOfCare?.id ?? null,
            ProviderId: this.providerSelected?.value ?? null,
            StartDateTime: this.startDate ?? null,
            EndDateTime: this.endDate ?? null,
            ServiceId: this.service?.value ?? null,
            Status: this.appointmentRequestData.status ?? null,
            LocationId: this.selectedLocation ?? null,
            PlaceOfServiceId: this.placeOfService?.value ?? null
          };
          if (this.isAnyFillInsurancesForm()) {
            if (this.validateInsuranceSubmit()) {
              (appointment["InsuranceId"] =
                this.insuranceSelected?.value ?? null),
                (appointment["InsuranceCardFrontBase64"] =
                  this.images.insuranceCardFrontBase64 ?? null);
              appointment["InsuranceCardBackBase64"] =
                this.images.insuranceCardBackBase64 ?? null;
              appointment["MemberIdentifyer"] = this.memberIdentifier ?? null;
              appointment["GroupNo"] = this.groupNo ?? null;
              appointment["InsuranceRelationshipId"] =
                this.relationshipSelected.value ?? null;
              if (this.relationshipSelected.label != "Self") {
                appointment[
                  "SubscriberFirstName"
                ] = this.subscriberInfo.firstName;
                appointment[
                  "SubscriberMiddleName"
                ] = this.subscriberInfo.middleName;
                appointment[
                  "SubscriberLastName"
                ] = this.subscriberInfo.lastName;
                appointment["SubscriberDateOfBirth"] =
                  this.subscriberInfo.dateOfBirth != null
                    ? this.formatDateTimeSql(this.subscriberInfo.dateOfBirth)
                    : null;
                appointment[
                  "SubscriberGenderId"
                ] = this.subscriberInfo.gender?.value;
                appointment["SubscriberPhone"] = this.subscriberInfo.phone;
                appointment[
                  "SubscriberAddressLine1"
                ] = this.subscriberInfo.addressLine1;
                appointment[
                  "SubscriberAddressLine2"
                ] = this.subscriberInfo.addressLine2;
                appointment["SubscriberCity"] = this.subscriberInfo.city;
                appointment[
                  "SubscriberStateId"
                ] = this.subscriberInfo.state?.value;
                appointment["SubscriberZipcode"] = this.subscriberInfo.zipcode;
              }
            } else {
              return false;
            }
          }
          await AppointmentRequestServer.update(
            this.appointmentRequestIdLocal,
            appointment
          );
        } else {
          const appt = this.appointmentRequestData;
          appt.providerId = this.providerSelected?.value;
          appt.startDateTime = this.formatDateTimeSql(this.startDate);
          appt.endDateTime = this.formatDateTimeSql(this.endDate);
          appt.serviceId = this.service?.value;
          appt.locationId = this.selectedLocation;
          appt.episodeOfCareId = this.appointmentRequestData.episodeOfCare?.id;
          appt.placeOfServiceId = this.placeOfService?.value;
          appt.insuranceId = this.appointmentRequestData.appointmentRequestInsurances[0]?.insuranceCompany.id;
          appt.insuranceCardFrontBase64 = this.images.insuranceCardFrontBase64;
          appt.insuranceCardBackBase64 = this.images.insuranceCardBackBase64;
          appt.memberIdentifyer = this.appointmentRequestData.appointmentRequestInsurances[0]?.memberIdentifier;
          appt.insuranceRelationshipId = this.appointmentRequestData.appointmentRequestInsurances[0]?.relationship.id;

          await AppointmentRequestServer.update(
            this.appointmentRequestIdLocal,
            appt
          );
        }
        await AppointmentRequestServer.approve(this.appointmentRequestIdLocal, {
          zoomMeeting: this.zoomMeeting,
          teamsMeeting: this.teamsMeeting
        })
          .then(async result => {
            isOk = true;
            if (this.newPortalUser) {
              await PortalAccessServer.grantAccess(
                result,
                this.appointmentRequestData.email
              );
            }
          })
          .catch(error => {
            this.showError({
              message: error.response.data.message
            });
            return;
          });
      }

      if (isOk) {
        if (nextAppointment == null || nextAppointment == "") {
          this.closeModal();
        } else {
          this.appointmentRequestIdLocal = nextAppointment.id;
          await this.fetchData();
          await this.fillValues();
          this.denied = false;
          this.approved = false;
        }
        this.showAlertSuccess();
      }
    },
    closeModal() {
      this.$emit("onModify");
    },
    async downloadImage(imageId) {
      const result = await avatarServer.downloadUrl(imageId);
      return result;
    },
    getImageUrl(imageId) {
      const viewUrl = this.$router.resolve(
        `/view-original-avatar/${serverCore.getToken()}/${imageId}`
      );
      return viewUrl.href;
    }
  },
  computed: {
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    ...mapState("client", {
      relationships: state =>
        state.relationships.map(relationship => ({
          value: relationship.id,
          label: relationship.name
        })),
      genders: state =>
        state.genders.map(gender => ({
          value: gender.id,
          label: gender.name
        })),
      states: state =>
        state.states.map(s => ({
          label: s.name,
          value: s.id,
          data: s
        })),
      placesOfService: state =>
        state.placesOfService.map(placeOfService => ({
          value: placeOfService.id,
          label: `${placeOfService.code}-${placeOfService.name}`,
          data: placeOfService
        }))
    }),
    ...mapState("layout", {
      selectedLocation: state => state.selectedLocation,
      location: state => state.selectedLocationObj,
      isZoomEnabled: state => state.systemSetting.isZoomEnabled,
      isTeamsEnabled: state => state.systemSetting.isTeamsEnabled,
      isEMAREnabled: state => state.systemSetting?.emarEnabled
    }),
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    providerOptions() {
      return this.users.filter(u => u.data.providerInfo);
    },
    startDate() {
      if (!this.appointmentStartDate) {
        return null;
      }

      return this.formatDateTimeSql(this.appointmentStartDate);
    },
    endDate() {
      if (!this.startDate || !this.duration) {
        return null;
      }
      const dateTime = moment(this.startDate).add(this.duration, "minutes");

      return this.formatDateTimeSql(dateTime);
    },

    activePhoneCountry() {
      return (
        this.$refs.phoneInput.$refs.telInput.activeCountry?.dialCode ?? "1"
      );
    },
    activeLineNumberCountry() {
      return (
        this.$refs.landPhoneInput.$refs.telInput.activeCountry?.dialCode ?? "1"
      );
    }
  }
};
</script>

<style scoped lang="scss">
.new-verification-modal {
  .v-select.vs--disabled .vs__dropdown-toggle {
    background-color: #f8f8f8 !important;
  }

  .insurance-company-picker-hide-options {
    .vs__dropdown-menu {
      display: none;
    }

    .vs--open .vs__dropdown-toggle {
      border-bottom-color: #4044e6 !important;
      border-bottom-width: 2px;
    }
  }
}
</style>
<style scoped>
.member-type >>> .custom-radio {
  margin-right: 20px !important;
}
</style>
